module.exports = __webpack_public_path__ + "static/media/smart-farm.cde87146.svg";